import { PLATFORMS } from '../../UserSettings/constants';

// Single Searches
export const setPlatformByParserSourcePlatform = (data, rootStore) => {
  if (data.parsedData?.source_platform === 'linkedin-public') {
    rootStore.userSettings.setPlatform('linkedin-public');
  }

  if (data.parsedData?.source_platform === 'LI Recruiter Pro') {
    rootStore.userSettings.setPlatform(PLATFORMS.LINKEDIN_RECRUITER_PRO);
  }

  if (data.parsedData?.source_platform === 'LI Recruiter Lite') {
    rootStore.userSettings.setPlatform(PLATFORMS.LINKEDIN_RECRUITER_LITE);
  }
};

